import { PointInformation } from '../type';
import { useApiRequest } from '../useApiRequest';

export function getLevelInformationOfCustomer() {
  return useApiRequest<PointInformation>(`membership-information`, `GET`);
}
